export class NilePaConstants {
	public static readonly DEFAULT_CURRENCIES = 'GBP,EUR,USD,CHF,DKK,SEK,NOK';
	public static readonly DEFAULT_BENCHMARKS = `BRS2NHT69,BRS86N7Y5,BRS3RP8V3,BRSCJ3SB3,BRSRHC0K2,BRS7ZVX51`;
	public static readonly BENCHMARKS = 'benchmarks';
	public static readonly ASSET_TYPES = 'assetTypes';
}
